import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import { ObjectBindingInfo } from "sap/ui/base/ManagedObject";
import { Button$PressEvent } from "sap/m/Button";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import { Binding$ChangeEvent } from "sap/ui/model/Binding";


/**
 * @namespace webapp.base.controller
 * */
export default class DisplayTypeController extends BaseTypeController {
  protected parameters: object;

  ///////////////////////
  //RouteFunction///////
  //////////////////////
  public onRoutePatternMatched(event: Route$PatternMatchedEvent) {

    const path: string = decodeURIComponent((event.getParameter("arguments") as any).path);
    const bindingInfo: ObjectBindingInfo = { path: path };

    if (this.parameters) {
      bindingInfo.parameters = this.parameters;
    }
    bindingInfo.events = {
      change: async (event: Binding$ChangeEvent) => {
        await this._afterViewBound(event);
      },
    };
    this.resetInputValueState(this.getView());
    this.getView().bindElement(bindingInfo);
  }
  ///////////////////////
  //ButtonEvents///////
  //////////////////////

  protected onCancel() {
    this.onToggleEdit();
  }

  protected async onEditSave(event: Button$PressEvent) : Promise<void> {
    try {
      /*  await this.onSave(event);
        this.navBack();*/
    } catch (error: any) {
      throw new Error(error);
    }
  }

  protected onToggleEdit() :void {
    try {
      if (this.viewModel.getProperty("/isEditable")) {
        const oModel: ODataModel = this.getModel() as ODataModel;
        oModel.resetChanges();
      }
      this.viewModel.setProperty("/isEditable", !this.viewModel.getProperty("/isEditable"));
    } catch (e: any) {
      throw new Error(e);
    }
  }
  ///////////////////////
  //HelperMethods///////
  //////////////////////

  protected async _afterViewBound(event:Binding$ChangeEvent): Promise<void> {

  }


}
